import { shuffle } from "lodash"

const questions = [
    {
        "question": "A flashing red traffic light signifies that a driver should do what?",
        "A": "stop",
        "B": "speed up",
        "C": "proceed with caution",
        "D": "honk the horn",
        "answer": "A"
      },
      {
        "question": "A knish is traditionally stuffed with what filling?",
        "A": "potato",
        "B": "creamed corn",
        "C": "lemon custard",
        "D": "raspberry jelly",
        "answer": "A"
      },
      {
        "question": "A pita is a type of what?",
        "A": "fresh fruit",
        "B": "flat bread",
        "C": "French tart",
        "D": "friend bean dip",
        "answer": "B"
      },
      {
        "question": "A portrait that comically exaggerates a person's physical traits is called a what?",
        "A": "landscape",
        "B": "caricature",
        "C": "still life",
        "D": "Impressionism",
        "answer": "B"
      },
      {
        "question": "A second-year college student is usually called a what?",
        "A": "sophomore",
        "B": "senior",
        "C": "freshman ",
        "D": "junior ",
        "answer": "A"
      },
      {
        "question": "A student who earns a J.D. can begin his or her career as a what?",
        "A": "lawyer",
        "B": "bricklayer",
        "C": "doctor",
        "D": "accountant",
        "answer": "A"
      },
      {
        "question": "A triptych is a work of art that is painted on how many panels?",
        "A": "two",
        "B": "three",
        "C": "five",
        "D": "eight",
        "answer": "B"
      },
      {
        "question": "According to a famous line from the existentialist play 'No Exit' what is hell?",
        "A": "oneself",
        "B": "other people",
        "C": "little made large",
        "D": "hued in green and blue",
        "answer": "B"
      },
      {
        "question": "According to a popular slogan, what state should people not 'mess with'?",
        "A": "New York",
        "B": "Texas",
        "C": "Montana",
        "D": "Rhode Island",
        "answer": "B"
      },
      {
        "question": "According to a Yale University study, what smell is the most recognizable to American adults?",
        "A": "tuna",
        "B": "laundry",
        "C": "popcorn",
        "D": "coffee",
        "answer": "D"
      },
      {
        "question": "According to folklore, the 'jackalope' is an antlered version of what animal?",
        "A": "chicken",
        "B": "rabbit",
        "C": "moose",
        "D": "snake",
        "answer": "B"
      },
      {
        "question": "According to Greek mythology, who was Apollo's twin sister?",
        "A": "Aphrodite",
        "B": "Artemis",
        "C": "Venus",
        "D": "Athena",
        "answer": "B"
      },
      {
        "question": "According to legend, if you give someone the 'evil eye' what are you doing?",
        "A": "cursing them",
        "B": "blessing a child",
        "C": "counting money",
        "D": "passing time",
        "answer": "A"
      },
      {
        "question": "According to legend, in what country are you most likely to meet a leprechaun?",
        "A": "Ireland",
        "B": "Poland",
        "C": "Greenland",
        "D": "Scotland",
        "answer": "A"
      },
      {
        "question": "According to the American Kennel Club, what is the most popular breed of dog in the US as of 1999?",
        "A": "Poodle",
        "B": "Beagle",
        "C": "German shepherd",
        "D": "Labrador retriever",
        "answer": "D"
      },
      {
        "question": "According to the Bible, Moses and Aaron had a sister named what?",
        "A": "Jochebed",
        "B": "Ruth",
        "C": "Leah",
        "D": "Miriam",
        "answer": "D"
      },
      {
        "question": "According to the children's nursery rhyme, what type of ocean did Columbus sail in 1492?",
        "A": "calm",
        "B": "blue",
        "C": "windy",
        "D": "really big",
        "answer": "B"
      },
      {
        "question": "According to the Mother Goose nursery rhyme, which child is full of woe?",
        "A": "Monday's child",
        "B": "Wednesday's child",
        "C": "Thursday's child",
        "D": "Saturday's child",
        "answer": "B"
      },
      {
        "question": "According to the popular saying, what should you do 'when in Rome'?",
        "A": "watch your wallet",
        "B": "see the Coliseum",
        "C": "as the Romans do",
        "D": "don't drink the water",
        "answer": "C"
      },
      {
        "question": "According to the proverb, necessity is the mother of what?",
        "A": "Invention",
        "B": "Luck",
        "C": "Problems",
        "D": "Procrastination",
        "answer": "A"
      },
      {
        "question": "According to the title of a popular children's TV show, what color is Bear's big house?",
        "A": "red",
        "B": "green",
        "C": "purple",
        "D": "blue",
        "answer": "D"
      },
      {
        "question": "According to the USDA, which food group should you eat the most servings of per day?",
        "A": "vegetables",
        "B": "dairy",
        "C": "meats",
        "D": "breads",
        "answer": "D"
      },
      {
        "question": "Ada Lovelace is credited with being the first person to have made what?",
        "A": "a computer program",
        "B": "a souffle",
        "C": "a brassiere",
        "D": "a mystery novel",
        "answer": "A"
      },
      {
        "question": "After Prince Charles, who is next in line to be the king of England?",
        "A": "Prince William",
        "B": "Prince Andrew",
        "C": "Prince Edward",
        "D": "Fresh Prince",
        "answer": "A"
      },
      {
        "question": "An airplane's black box is usually what color?",
        "A": "black",
        "B": "white",
        "C": "orange",
        "D": "purple",
        "answer": "C"
      },
      {
        "question": "As of 1999, which state has the most Girl Scouts?",
        "A": "California",
        "B": "Illinois",
        "C": "New York",
        "D": "Pennsylvania",
        "answer": "A"
      },
      {
        "question": "Astronaut John Glenn served as a pilot in what branch of the military?",
        "A": "Army",
        "B": "Air Force",
        "C": "Marines",
        "D": "Navy",
        "answer": "C"
      },
      {
        "question": "At the equator, how fast is the earth's surface turning?",
        "A": "about 100 miles per hour",
        "B": "about 500 miles per hour",
        "C": "about 1000 miles per hour",
        "D": "about 2000 miles per hour",
        "answer": "C"
      },
      {
        "question": "At what age can someone first attend an R-rated movie without an accompanying adult?",
        "A": "15",
        "B": "17",
        "C": "18",
        "D": "21",
        "answer": "C"
      },
      {
        "question": "Backgammon is a how many player game?",
        "A": "Two",
        "B": "Three",
        "C": "Four",
        "D": "Six",
        "answer": "A"
      },
      {
        "question": "Before he went into coaching, Phil Jackson played for which of the following NBA teams?",
        "A": "Boston Celtics",
        "B": "Los Angeles Lakers",
        "C": "New York Knicks",
        "D": "Philadelphia 76ers",
        "answer": "C"
      },
      {
        "question": "By what name is Bob Keeshan better known?",
        "A": "Bozo the Clown",
        "B": "Pee Wee Herman",
        "C": "Captain Kangaroo",
        "D": "Buffalo Bob",
        "answer": "C"
      },
      {
        "question": "By what collective name do Christians refer to God the Father, God the Son and the Holy Ghost?",
        "A": "the Trio",
        "B": "the Troika",
        "C": "the Triumvirate",
        "D": "the Trinity",
        "answer": "D"
      },
      {
        "question": "By what nickname is the Federal National Mortgage Association known?",
        "A": "Morty",
        "B": "FEMA",
        "C": "Freddie Mac",
        "D": "Fannie Mae",
        "answer": "D"
      },
      {
        "question": "Cheddar cheese got its name from a village in what country?",
        "A": "England",
        "B": "France",
        "C": "Switzerland",
        "D": "Denmark",
        "answer": "A"
      },
      {
        "question": "Cheese is a necessary ingredient in which of these dishes?",
        "A": "sushi",
        "B": "french fries",
        "C": "veal parmigiano",
        "D": "chicken pot pie",
        "answer": "C"
      },
      {
        "question": "During what war did Francis Scott Key write the words to 'The Star-Spangled Banner'?",
        "A": "American Revolution",
        "B": "War of 1812",
        "C": "Civil War",
        "D": "World War I",
        "answer": "B"
      },
      {
        "question": "During which war did US troops fight the Battle of New Orleans?",
        "A": "American Revolution",
        "B": "Civil War",
        "C": "Mexican War",
        "D": "War of 1812",
        "answer": "D"
      },
      {
        "question": "Each year in pro baseball, the player voted as the best fielder at his position wins what?",
        "A": "a brand new car",
        "B": "the Gold Glove",
        "C": "the Silver Bat",
        "D": "the Brass Baseball",
        "answer": "B"
      },
      {
        "question": "Elephant tusks are made of what material?",
        "A": "coral",
        "B": "ivory",
        "C": "bone",
        "D": "calcium",
        "answer": "B"
      },
      {
        "question": "Excluding wisdom teeth, how many adult teeth do humans have?",
        "A": "28",
        "B": "32",
        "C": "35",
        "D": "40",
        "answer": "A"
      },
      {
        "question": "For a man and woman on a date, 'dutch treat' means what?",
        "A": "the man pays",
        "B": "the woman pays",
        "C": "the Dutch pay",
        "D": "each pays their own way",
        "answer": "D"
      },
      {
        "question": "For what purpose would you use an awl?",
        "A": "to shoot ducks",
        "B": "to polish floors",
        "C": "to make holes",
        "D": "to weigh fruit",
        "answer": "C"
      },
      {
        "question": "From 1971 to 1997, the Democratic Republic of Congo was known as what?",
        "A": "Zaire",
        "B": "Angola",
        "C": "Rhodesia",
        "D": "Belgian Congo",
        "answer": "A"
      },
      {
        "question": "From what language does the term 'R.S.V.P.' originate?",
        "A": "Russian",
        "B": "Italian",
        "C": "Portuguese",
        "D": "French",
        "answer": "D"
      },
      {
        "question": "From whom does the Lutheran Church get its name?",
        "A": "Martin Luther King Jr",
        "B": "Martin Luther",
        "C": "Luther Vandross",
        "D": "Lex Luthor",
        "answer": "B"
      },
      {
        "question": "Gerry Adams is the president of what organization?",
        "A": "Greenpeace",
        "B": "NASCAR",
        "C": "Sinn Fein",
        "D": "PLO",
        "answer": "C"
      },
      {
        "question": "Girls of what religious community traditionally wear bonnets?",
        "A": "Amish",
        "B": "Sikh",
        "C": "Roman Catholic",
        "D": "Christian",
        "answer": "A"
      },
      {
        "question": "How are actors Charlie Sheen and Emilio Estevez related?",
        "A": "they're cousins",
        "B": "they're brothers",
        "C": "they're father and son",
        "D": "they're uncle and nephew",
        "answer": "B"
      },
      {
        "question": "How do you express 3/4 as a decimal?",
        "A": ".25",
        "B": ".50",
        "C": ".75",
        "D": ".90",
        "answer": "C"
      }
]
const shuffledQuestion = shuffle(questions)

export default shuffledQuestion